import { render, staticRenderFns } from "./riskList.vue?vue&type=template&id=72d36b3c"
import script from "./riskList.vue?vue&type=script&lang=js"
export * from "./riskList.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/opt/buildhome/repo/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('72d36b3c')) {
      api.createRecord('72d36b3c', component.options)
    } else {
      api.reload('72d36b3c', component.options)
    }
    module.hot.accept("./riskList.vue?vue&type=template&id=72d36b3c", function () {
      api.rerender('72d36b3c', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/pages/ram/riskList.vue"
export default component.exports